import script from "./DesktopLinks.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesktopLinks.vue?vue&type=script&lang=ts&setup=true"

import "./DesktopLinks.vue?vue&type=style&index=0&id=f85475fa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f85475fa"]])

export default __exports__